import React, { useState, useEffect } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { useSelector } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'

import classnames from 'classnames'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Link as MaterialLink } from '@material-ui/core'

import FormGroup from '@material-ui/core/FormGroup'
import Checkbox from '@material-ui/core/Checkbox'

import { withSnackbar } from 'notistack';

const styles = (theme) => ({
    error: {
        color: 'indianred'
    },
    link: {
        color: theme.palette.primary.main + ' !important',
        cursor: 'pointer'
    },
    marginTop1: {
        marginTop: theme.spacing(1)
    },
    bgTransparent: {
        background: 'transparent'
    },
    bgWhite: {
        background: 'white'
    },
    borderEnabled: {
        border: '1px solid #161717'
    },
})

const BankAccountForm = ({ handleTokenCallback, cart, disabled, handleReserveCase, handleSelectedCardCase, classes, cards, cardDefault, enqueueSnackbar }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [clicked, setClicked] = useState(false);
    const [acctNumber, setAcctNumber] = useState()
    const [routing, setRouting] = useState()
    const currentUser = useSelector(state => state.authentication.currentUser)
    const [payTermsAndCond] = useState(disabled)
    const [checkBoxPayTerms, setCheckBoxPayTerms] = useState(disabled)


    useEffect(() => {
        console.log(cart);
    }, [])



    const onAcctNumberChange = (e) => {
        setAcctNumber(e.target.value)
    }
    const onRoutingChange = (e) => {
        setRouting(e.target.value)
    }


    const handleRecurringPayTermsChange = (e) => {
        setCheckBoxPayTerms(e.target.checked)
    }


    const handleSubmit = async event => {
        event.preventDefault();


        // To prevent double clicks
        if (clicked) {
            return;
        }


        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }


        const result = await stripe.createToken('bank_account', {
            country: 'US',
            currency: 'usd',
            routing_number: routing,
            account_number: acctNumber,
            account_holder_name: currentUser.name,
            account_holder_type: 'individual'
        });

        if (result.error) {
            // Show error to your customer.
            enqueueSnackbar(result.error.message, { variant: 'error', autoHideDuration: 2000 });

            console.log(result.error.message);
        } else {
            // Send the token to your server.
            // This function does not exist yet; we will define it in the next step.
            //stripeTokenHandler(result.token);
            console.log("[Token]", result.token);
            setClicked(true);

            handleTokenCallback(result.token, (err) => {
                if (err) {
                    enqueueSnackbar(err, { variant: 'error', autoHideDuration: 2000 });
                    setClicked(false);
                }

            });


        }


    };

    return (
        <form onSubmit={handleSubmit} noValidate autoComplete="off">

            <Grid container spacing={3} alignItems="center">
                <Grid item xs>
                    <Paper style={{ padding: '14px 12px', border: '1px solid #e3e6eb', borderRadius: 10 }}>
                        <Grid container alignItems="center">
                            <Grid item xs={12}><Paper className={classes.bgTransparent}>Bank Account Number</Paper></Grid>
                            <Grid item xs><Paper className={classnames(classes.bgWhite, classes.borderEnabled)}><TextField InputProps={{ disableUnderline: true }} fullWidth placeholder={'27112612612712'} value={acctNumber} onChange={onAcctNumberChange} /></Paper></Grid>
                        </Grid>

                        <Grid container className={classes.marginTop1} alignItems="center">
                            <Grid item xs={12} ><Paper className={classes.bgTransparent}>Routing Number</Paper></Grid>
                            <Grid item xs><Paper className={classnames(classes.bgWhite, classes.borderEnabled)}><TextField InputProps={{ disableUnderline: true }} fullWidth placeholder={'1231231232'} value={routing} onChange={onRoutingChange} /></Paper></Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>

            <Grid container item style={{ padding: '12px' }}>
                * This method will involve manual verification via - microdeposits and will take atleast 2 days to get verified.
                Please use  online banking option to add instantly.
            </Grid>

            <Grid container spacing={3} alignItems="center" style={{ padding: '12px' }}>
                <Grid item >
                    {!payTermsAndCond && <FormGroup aria-label="position" row>
                        <FormControlLabel
                            value="end"
                            control={<Checkbox color="primary" value={checkBoxPayTerms} onChange={handleRecurringPayTermsChange} />}
                            label={<div>I agree to the recurring payment <MaterialLink target="_blank" href="https://register.tanglewoodresort.club/#/recurring-payment-terms">terms and conditions</MaterialLink>.</div>}
                            labelPlacement="end"
                        />
                    </FormGroup>}
                </Grid>

                <Grid container item xs justify="flex-end">

                    <Button type="submit" disabled={!stripe || clicked || !checkBoxPayTerms} variant="contained" size="large" name="MakePaymentBtn" color="primary" >
                        ADD BANK ACCOUNT
                    </Button>
                </Grid>
            </Grid>

        </form>
    );
};

export default withStyles(styles)(withSnackbar(BankAccountForm));
